<div class="container-fluid">
  @if (sessionExpiredMessage) {
    <div class="alert alert-warning">
      {{ sessionExpiredMessage }}
    </div>
  }
  <div class="row">
    <div
      class="col-12 d-flex justify-content-center align-items-center"
      style="min-height: 80vh"
    >
      <mat-card class="example-card">
        <mat-card-header>
          <div style="display: flex; justify-content: center; width: 100%">
            <img
              mat-card-image
              src="../../../assets/images/klusup.png"
              alt="Klusup Logo"
              width="120px"
              height="50px"
              class="mr-auto"
            />
          </div>
        </mat-card-header>
        <mat-card-subtitle class="login-text text-center mt-4"
          >Login</mat-card-subtitle
        >
        <mat-card-content>
          <form [formGroup]="loginForm">
            @if (!showPasscode) {
              <input
                type="email"
                formControlName="userName"
                placeholder="User Name"
              />
            }
            @if (!showPasscode) {
              <button (click)="loginHere()" class="login-btn">
                Get Verification Code
              </button>
            }

            @if (showPasscode) {
              <input
                type="email"
                formControlName="passcode"
                placeholder="Enter passcode sent to your mail"
                required
              />
            }
          </form>
        </mat-card-content>
        <mat-card-actions>
          @if (showPasscode) {
            <div>
              <p>{{ timeLeft }} Seconds Left....</p>
              @if (timeLeft <= 10) {
                <button class="resend-btn" (click)="loginHere()">Resend</button>
              }
            </div>
          }

          @if (showPasscode) {
            <button
              (click)="validateLoginToken()"
              [disabled]="
                loginForm.invalid || !loginForm.get('passcode')?.value
              "
            >
              Submit
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
